import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>LIF Payment</h1>
        <iframe src="https://www.financialcalculators.net/librocu/lif-payment/" title="LIF Calculator" scrolling="no"
                frameBorder="0"></iframe>
        <IframeResize/>
    </div>
);
